/**
 * Cuánto alto tiene que conservar una lista que va a encoger.
 *
 * Filtrar una lista larga acorta la página, y una página más corta no puede
 * sostener el desplazamiento en el que estaba: el navegador lo recorta al nuevo
 * máximo y la vista sube sola. Nadie pidió ese movimiento — se estaba leyendo
 * algo en su sitio y el sitio se movió.
 *
 * La cuenta reserva lo justo para que el desplazamiento actual siga siendo
 * alcanzable, y ni un pixel más: el borde inferior de lo reservado cae
 * exactamente en el borde inferior de lo que se está viendo. Así el hueco vacío
 * nunca pasa de una pantalla, por mucho que la lista haya encogido.
 */

export interface ScrollerBox {
  /** Alto visible del contenedor que hace scroll. */
  readonly viewport: number;
  /**
   * Dónde empieza el cuerpo respecto al borde superior de lo visible.
   * Negativo cuando ya se pasó de largo y el cuerpo empieza más arriba.
   */
  readonly offset: number;
  /** Alto del contenido que viene después del cuerpo y ya sostiene su parte. */
  readonly tail: number;
}

export const reservedHeight = ({ viewport, offset, tail }: ScrollerBox): number =>
  /*
   * Un `viewport` de cero es un contenedor que no hace scroll —lo que ocurre
   * cuando la página cabe entera—, y ahí no hay nada que sostener: la cuenta da
   * cero sola, sin necesidad de un caso aparte.
   */
  Math.max(0, Math.round(viewport - offset - tail));
